














































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
import communicationRepository from '@/services/communicationRepository';
import Card from '@/components/default/Card.vue';
import DxList from 'devextreme-vue/list';
import { CommunicationsClient, MailsClient, SendMailCommand } from '@/data/web-api-client';
import AxiosClient from '@/data/AxiosClient';
import CommunicationTypeMail from '@/modules/projects/components/communication/CommunicationTypes/CommunicationTypeMail.vue';
import CommunicationTypeNote from '@/modules/projects/components/communication/CommunicationTypes/CommunicationTypeNote.vue';
import CommunicationTypeActivity from '@/modules/projects/components/communication/CommunicationTypes/CommunicationTypeActivity.vue';
import { CommunicationType } from '@/data/web-api-client';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import CommunicationNotePopup from '@/modules/projects/components/communication/CommunicationPopups/CommunicationNotePopup.vue';
import CommunicationEmailPopup from '@/modules/projects/components/communication/CommunicationPopups/CommunicationEmailPopup.vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import MailDialog from '@/components/default/MailPopup.vue';

@Component({
  components: {
    DxFileUploader,
    DxProgressBar,
    Card,
    DxList,
    CommunicationTypeMail,
    CommunicationTypeNote,
    CommunicationTypeActivity,
    CommunicationNotePopup,
    CommunicationEmailPopup,
    DxSimpleItem,
    DxLabel,
    DxForm,
    DxLoadPanel,
    MailDialog,
  },
  data() {
    return {
      isDropZoneActive: false,
      imageSource: '',
      textVisible: true,
      progressVisible: false,
      progressValue: 0,
      allowedFileExtensions: ['.msg', '.eml'],
    };
  },
})
export default class ProjectCommunicationTable extends Vue {
  @Prop({ required: true })
  project!: any;

  communications: any[] = [];

  communicationTypes: any[] = [];
  communicationType: any = CommunicationType;
  isLoading: boolean = false;
  fullPage: boolean = true;
  isDropZoneActive: boolean = false;

  showActivity: boolean = false;
  showMail: boolean = true;
  showNote: boolean = true;
  searchValue: string = '';

  get listDataSource() {
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          this.startLoading();
          return await communicationRepository
            .lookup(loadOptions, this.project.id, 'Project', {
              showActivity: this.showActivityData(),
              showMail: this.showMailData(),
              showNote: this.showNoteData(),
              searchString: this.getSearchValue(),
            })
            .then((result) => {
              this.stopLoading();
              return result;
            });
        },
      }),
      paginate: true,
      pageSize: 10,
    });
  }

  mounted() {
    this.getCommunicationTypes();
  }

  showActivityData() {
    return this.showActivity;
  }

  showMailData() {
    return this.showMail;
  }

  showNoteData() {
    return this.showNote;
  }

  getSearchValue() {
    return this.searchValue;
  }

  startLoading() {
    this.isLoading = true;
  }

  stopLoading() {
    this.isLoading = false;
  }

  public async onProgress(e: any) {
    this.startLoading();
    var formData = new FormData();
    formData.append('file', e.file);
    await communicationRepository.update(this.project.id, formData).then(() => {
      this.refreshTable();
    });
  }

  onDropZoneEnter(e: any) {
    if (e.dropZoneElement.id === 'dropzone-external') {
      this.isDropZoneActive = true;
    }
  }

  onDropZoneLeave(e: any) {
    if (e.dropZoneElement.id === 'dropzone-external') {
      this.isDropZoneActive = false;
    }
  }

  public getCommunicationTypes() {
    for (const value of Object.keys(CommunicationType)) {
      if (!isNaN(Number(value))) {
        this.communicationTypes.push({
          key: parseInt(value),
          value: CommunicationType[parseInt(value)],
          showOnList: parseInt(value) == CommunicationType.Activity ? false : true,
        });
      }
    }
    return this.communicationTypes;
  }

  public changeFilter(type: CommunicationType) {
    var value = this.communicationTypes[type];
    value.showOnList = !value.showOnList;
    switch (type) {
      case CommunicationType.Activity:
        this.showActivity = !this.showActivity;
        break;
      case CommunicationType.Mail:
        this.showMail = !this.showMail;
        break;
      case CommunicationType.Note:
        this.showNote = !this.showNote;
        break;
    }
    this.refreshTable();
  }

  refreshTable() {
    (this.$refs.DxList as DxList).instance!.reload();
    this.isDropZoneActive = false;
  }

  addOrUpdateNote(note: any) {
    (this.$refs.CommunicationNotePopup as CommunicationNotePopup).Open(note);
  }

  openMail(communication: any) {
    (this.$refs.CommunicationEmailPopup as CommunicationEmailPopup).Open(communication);
  }

  async deleteCommunication(id: string) {
    if (window.confirm('Moet deze record verwijderd worden?')) {
      await new CommunicationsClient(undefined, AxiosClient).deleteCommunication(id).then((result) => {
        this.refreshTable();
      });
    }
  }

  deleteSearch() {
    this.searchValue = '';
    this.refreshTable();
  }

  openMailDialog() {
    (this.$refs.MailDialog as MailDialog).open();
  }

  async sendMail(mailInfo: SendMailCommand) {
    const client = new MailsClient(undefined, this.$axios);

    mailInfo.objectId = this.project.id;

    await client.sendMail(new SendMailCommand(mailInfo));

    this.refreshTable();
  }

  get contacts() {
    if (!this.project || !this.project.contacts || this.project.contacts.length == 0) {
      return [];
    }

    return this.project.contacts.map((c: any) => c.contact);
  }
}
